import { render, staticRenderFns } from "./SportsCompex.vue?vue&type=template&id=07b5916a&scoped=true&"
import script from "./SportsCompex.vue?vue&type=script&lang=js&"
export * from "./SportsCompex.vue?vue&type=script&lang=js&"
import style0 from "./SportsCompex.vue?vue&type=style&index=0&id=07b5916a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b5916a",
  null
  
)

export default component.exports